module.exports = __webpack_public_path__ + "videos/oabot_bg_low.6307548.mp4";